import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { CreationTypes, UserInfoType } from '../../types/loginTypes';
import { TERMS_AND_CONDITIONS } from '../../routes/routes';
import { setUserRegisterToLS } from '../../helpers/localstorage-helper';
import { ErrorToast } from '../../components';
import axios from 'axios';

interface GetReferrerValidationType {
  referrerId: number;
  result: any;
  history: any;
}

export const getReferrerValidation = createAsyncThunk(
  'auth/getReferrerValidation',
  async (
    { referrerId, result, history }: GetReferrerValidationType,
    { rejectWithValue, getState, dispatch }
  ) => {
    const {
      lot_number: lotNumber,
      captcha_output: captchaOutput,
      pass_token: passToken,
      gen_time: genTime
    } = result;

    try {
      const state = getState() as RootState;

      const creationType = state.auth.register?.user?.creationType;
      const token = state.auth.register?.token;

      await axios.get(`/authorization/signup/refferer/${referrerId}/validate`, {
        params: {
          lotNumber,
          captchaOutput,
          passToken,
          genTime
        }
      });

      if (creationType === CreationTypes.Google) {
        dispatch(
          socialReferrer({
            referrerId,
            token,
            history
          })
        );
      } else {
        history.push({
          pathname: TERMS_AND_CONDITIONS
        });

        setUserRegisterToLS({
          referrerId,
          user: { creationType: CreationTypes.Local }
        });

        return { referrerId, user: { creationType: CreationTypes.Local } };
      }
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

interface SocialReferrerType {
  referrerId: number;
  token: any;
  history: any;
}

export const socialReferrer = createAsyncThunk(
  'auth/socialReferrer',
  async (
    { referrerId, token, history }: SocialReferrerType,
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        `/authorization/signup/social/refferer`,
        {
          referrerId: Number(referrerId),
          token
        }
      );

      const user = response.data.data.user as UserInfoType;

      setUserRegisterToLS({ referrerId, user, token });

      history.push(TERMS_AND_CONDITIONS);

      return { referrerId, user, token };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
